/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-03-04 14:24:31
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-10-27 12:21:38
 * @FilePath: /designcenter/src/utils/modules/request.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import { Base64 } from 'js-base64'
import CryptoJS from 'crypto-js'
import { useWebsiteInfoStore } from '@/store/websiteInfo'
import { Cookie, handleFsLink, parseUrlParams, setLoginUrl } from '@/utils'

// import { useUserStore } from '@/store/user'
import { FsMessage } from 'fs-design'

// import { message } from 'ant-design-vue'

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import type { IRes } from '@/types'

const genNonce = (num: number) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  let str = ''
  for (let i = 0; i < num; i++) {
    const pos = Math.round(Math.random() * (chars.length - 1))
    str += chars[pos]
  }
  return str
}
const request: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 50000,
})

request.interceptors.request.use(
  config => {
    const websiteInfoStore = useWebsiteInfoStore()
    const timestamps = new Date().getTime()
    const nonce = genNonce(16)
    const apiKey = 'yuxuanxuanpc'
    const payload = '[]'
    const s = timestamps + nonce + payload
    const h = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, 'yuxuan3507')
    h.update(s)
    const signature = Base64.encode(CryptoJS.enc.Hex.stringify(h.finalize()))
    const urlParams = parseUrlParams()
    config.headers.timestamps = timestamps
    config.headers.nonce = nonce
    config.headers.apiKey = apiKey
    config.headers.clientSignature = signature
    const token = Cookie.get('token_new') || urlParams.token || location.search.split('token=')[1] || ''
    const fs_websiteinfo = JSON.parse(JSON.stringify(websiteInfoStore.$state))
    // console.log('wrw43423422')

    if (fs_websiteinfo) {
      config.headers['websiteinfo'] = Base64.encode(JSON.stringify(fs_websiteinfo))
    }
    if (token) {
      config.headers['authorization'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  async (response: AxiosResponse) => {
    if (response.config.responseType === 'blob') {
      const blob = response.data
      try {
        const text = await blob.text()
        const json = JSON.parse(text)
        // 如果能成功 parse，则说明其实是错误信息
        if (json.message) {
          FsMessage({
            type: 'danger',
            message: json.message,
          })
        }

        return Promise.reject(json)
      } catch (e) {
        // 解析失败，说明真的是文件，正常返回
        return response
      }
    }

    const res = response.data as unknown as IRes
    if (res.code >= 400) {
      //  && import.meta.env.PROD
      if (res.code === 401) {
        // userStore.logout()
        location.href = handleFsLink(`/login.html?redirect=${setLoginUrl()}`)
      } else {
        if (res.message) {
          FsMessage({
            type: 'danger',
            message: res.message,
          })
        }
      }
      return Promise.reject(res)
    }
    return response.data
  },
  error => {
    console.log('error_error')
    console.log(error)
    const res = (error.response?.data as unknown as IRes) || { msg: error.message || '' }
    // message.error(res.message); && import.meta.env.PROD
    if (error.status === 401) {
      location.href = handleFsLink(`/login.html?redirect=${setLoginUrl()}`)
      return
    } else {
      if (res.message) {
        FsMessage({
          type: 'danger',
          message: res.message,
        })
      }
    }
    return Promise.reject(res)
  }
)

class ApiRequest {
  private static instance: ApiRequest
  constructor(private request: AxiosInstance) {}

  public static getInstance(request: AxiosInstance): ApiRequest {
    if (!this.instance) this.instance = new ApiRequest(request)
    return this.instance
  }

  get<T>(url: string, config?: AxiosRequestConfig) {
    return this.request.get<T>(url, config) as unknown as Promise<T>
  }

  post<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.request.post<T>(url, data, config) as unknown as Promise<T>
  }

  put<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.request.put<T>(url, data, config) as unknown as Promise<T>
  }

  patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.request.patch<T>(url, data, config) as unknown as Promise<T>
  }

  delete<T>(url: string, config?: AxiosRequestConfig) {
    return this.request.delete<T>(url, config) as unknown as Promise<T>
  }
}

function getApiRequest() {
  return ApiRequest.getInstance(request)
}

export { request, getApiRequest }
